export const PUBLIC_FOLDER = process.env.PUBLIC_URL

// ToDo: This is not the right place for this
export type Option = 2 | 6 | 24

// Leaving this as a note here: type TimeUrls = { [key: number]: string }
type TimeUrls = Record<Option, string>

export const SPEED_URLS: TimeUrls = {
  24: PUBLIC_FOLDER + '/data/plasma-1-day.json',
  6: PUBLIC_FOLDER + '/data/plasma-6-hour.json',
  2: PUBLIC_FOLDER + '/data/plasma-2-hour.json',
}

export const BZ_URLS: TimeUrls = {
  24: PUBLIC_FOLDER + '/data/mag-1-day.json',
  6: PUBLIC_FOLDER + '/data/mag-6-hour.json',
  2: PUBLIC_FOLDER + '/data/mag-2-hour.json',
}

export const GEO_MAG_URLS = {
  nur: PUBLIC_FOLDER + '/data/NURdata_24.json',
  ouj: PUBLIC_FOLDER + '/data/OUJdata_24.json',
  muo: PUBLIC_FOLDER + '/data/MUOdata_24.json',
  iva: PUBLIC_FOLDER + '/data/IVAdata_24.json',
}

export const K_INDEX_URL = PUBLIC_FOLDER + '/data/noaa-planetary-k-index.json'
export const PREDICTED_K_INDEX_URL = PUBLIC_FOLDER + '/data/27-day-outlook.json'
export const PREDICTED_3_DAY_K_INDEX_URL = PUBLIC_FOLDER + '/data/3-day-forecast.json'
